import React from 'react';

import { View } from 'react-native';

import MaskEmpty from 'assets/images/svgs/ico_mask_empty.svg';
import MaskFilled from 'assets/images/svgs/ico_mask_filled.svg';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

type Props = {
    text: string;
};

export const maxCharacters = 4;

function PinMask({ text }: Props) {
    const activeIndex = text.length - 1;
    const array = getPinMaskArray(text);

    return (
        <View style={styles.container}>
            {array.map((char, index) => {
                if (index === activeIndex) {
                    return (
                        <View style={styles.item} key={`${index}`}>
                            <Text
                                category={ETextCategory.title1}
                                color={ETextColor.neutral}
                                style={styles.visibleCharacter}
                            >
                                {char}
                            </Text>
                        </View>
                    );
                } else if (typeof char === 'string') {
                    return (
                        <View style={styles.item} key={`${index}`}>
                            <MaskFilled />
                        </View>
                    );
                } else {
                    return (
                        <View style={styles.item} key={`${index}`}>
                            <MaskEmpty />
                        </View>
                    );
                }
            })}
        </View>
    );
}

export default PinMask;

function getPinMaskArray(text: string) {
    const array: Array<string | undefined> = text
        .split('')
        .slice(0, maxCharacters);
    array.length = 4;

    return array.fill(undefined, text.length, maxCharacters);
}
